import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SmallModal } from "../../SmallModal";
import { ReactiveFormSMSelect } from "../../form/ReactiveFormSMSelect";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../state/store";
import { useEffect, useMemo, useState } from "react";
import { Toast } from "../../Toast";
import { addBackupAgent } from "../../../state/users/actions";
import { toast, ToastContainer } from "react-toastify";
import { LoadingMask } from "../../LoadingMask";
import Select from "react-select";
import { User } from "../../../models/User";

interface Props {
    info: {
        show: boolean;
        agents?: User[];
    };
    onClose: () => void;
}

export const AddBackupAgentsModal: React.FC<Props> = ({
    info,
    onClose
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const [showAddBackupError, setShowAddBackupError] = useState(false);
    const isLoading = useSelector((state: RootState) => state.users.isBackupLoading);
    const error = useSelector((state: any) => state.users.backupError);
    const [currentAgents, setCurrentAgents] = useState<any[]>();

    useEffect(() => {
        if (showAddBackupError) {
            Toast(
                t(error?.reason ?? "SOMETHING_WENT_WRONG"),
                t(error?.cause_info)
            );
        }
    }, [showAddBackupError, error, t]);
    
    const methods = useForm<any>({
            defaultValues: {}
    })
    const { handleSubmit, control, reset } = methods;

    const onSubmit = async (data: any) => {
        const selectedAgents = info.agents?.filter((a) => {
            const index = currentAgents?.findIndex((bA) => a.id === +bA.value)
            return index !== -1;
        })

        const backUps = {
            backup_agents: selectedAgents
        }
        
        dispatch(addBackupAgent({data: backUps, backupAgent: selectedAgents!})).then((e) => {
            if (e.type === "users/addBackupAgent/rejected") {
                setShowAddBackupError(true);
            } else {
                toast(t("SUCCESSFULLY_ADD_BACKUP_AGENT"));
                closeModal();
            }
        });
    }
    
    const closeModal = () => {
        reset({});
        onClose();
    };

    const agents = useMemo(() => {
        return info.agents?.map((x: any) => {
            return {
            label: `${x.first_name} ${x.last_name}`,
            value: x.id,
            };
        });
    }, [info.agents]);
    
    return (<>
        <SmallModal
            isOpen={info.show}
            onClose={closeModal}
            label={t("ADD_BACKUP_AGENT")}
            onSave={handleSubmit(onSubmit)}
        >
            <div className="w-full pt-3 pb-5">
                <div className={"w-full px-3"}>
                    <div className={"w-full px-3"}>
                        <label className="block tracking-wide text-gray-700 text-sm mb-2">
                            {t("BACKUP_AGENT")}
                        </label>
                        <Select
                            isMulti
                            isSearchable
                            isClearable
                            isLoading={agents ? agents.length === 0 : false}
                            onChange={(inputValue: any) => setCurrentAgents(inputValue)}
                            name="agent"
                            options={agents}
                            value={currentAgents}
                            placeholder="Select agents"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            maxMenuHeight={200}
                            classNames={{
                                control: (state) =>
                                    'bg-white opacity-90 py-1 px-1.5 rounded shadow w-full min-w-[200px]',
                            }}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: 'grey-50',
                                }),
                            }}
                        />
                    </div>
                    <label className="text-gray-600 text-xs mb-5">
                        {t("BACKUP_AGENT_MESSAGE")}
                    </label>
                </div>
            </div>
        </SmallModal>
        <ToastContainer progressStyle={{ background: "#D4AF37" }} />
        { isLoading && <LoadingMask /> }
    </>)
}